<template>
  <div v-title data-title="新增收货地址">
    <wv-group>
      <wvi-input
        label="收货人"
        placeholder="收货人"
        ref="1"
        v-model="formset.ReceiverName"
        :validate-info="{errormsg:'收货人不可为空'}"
        required
      ></wvi-input>
      <wvi-input
        label="手机号码"
        placeholder="手机号码"
        ref="2"
        v-model="formset.ReceiverPhone"
        pattern="^[1][0-9]{10}$"
        maxlength="11"
        :validate-info="{errormsg:'手机号码不合法'}"
        required
      ></wvi-input>
      <wv-cell
        title="省市区"
        is-link
        :value="ProvinceAndCity| pickerValueFilter"
        @click.native="dayPickerShow = true"
        @change="onChange"
      />
      <wvi-input
        v-if="false"
        label="邮政编码"
        placeholder="邮政编码"
        ref="5"
        v-model="formset.Zipcode"
        pattern="[1-9]\d{5}(?!\d)"
        maxlength="6"
        :validate-info="{errormsg:'邮政编码不合法'}"
        required
      ></wvi-input>
      <wvi-textarea
        label="详细地址"
        placeholder="如道路、小区、楼栋号、单元室等"
        ref="6"
        v-model="formset.Address"
        :validate-info="{errormsg:'详细地址不可为空'}"
        required
      ></wvi-textarea>
    </wv-group>
    <wv-switch title="设为默认地址" v-model="formset.IsDefaultAddress"></wv-switch>
    <div class="weui-cell">
      <wv-button type="primary" @click="btnSave()">保存</wv-button>
    </div>

    <div class="weui-cell">
      <wv-button type="primary" @click="zhi()">智能识别</wv-button>
    </div>
       <div class="weui-cell">
           <lable>智能填写</lable>  
           <textarea  style="width:250px;height:100px;margin-left:10px" placeholder="黏贴如：福建省福州市福清市石竹街道义明综合楼3F，15000000000，asseek" v-model="Message"></textarea>
       </div>
    <wv-picker
      :visible.sync="dayPickerShow"
      :columns="dayColumns"
      v-model="ProvinceAndCity"
      @confirm="confirmDayTime"
    />
  </div>
</template>

<script>
import { Toast } from "we-vue";
import AddressParse from "address-parse";

export default {
  name: "deliveryaddressadd",
  data: function() {
    return {
      dayPickerShow: false,
      ProvinceAndCity: "",
      ProvinceAndCityold: ["", "", ""],
      formset: {},
      provinceWithCity: [],
      dayColumns: [
        {
          values: [],
          defaultIndex: 0
        },
        {
          values: [],
          defaultIndex: 0
        },
        {
          values: [],
          defaultIndex: 0
        }
      ]
    };
  },

  watch: {
    ProvinceAndCity(val) {
      debugger;
      var provincechilds = [];
      for (var i = 0; i < this.provinceWithCity.length; i++) {
        if (this.provinceWithCity[i].Name == this.ProvinceAndCity[0]) {
          provincechilds = this.provinceWithCity[i].Childs;
          break;
        }
      }
      var c = [];
      for (var i = 0; i < provincechilds.length; i++) {
        c.push(provincechilds[i].Name);
      }
      this.dayColumns[1].values = c;

      //省发生了变化
      if (this.ProvinceAndCityold[0] != this.ProvinceAndCity[0]) {
        var a = [];
        for (var i = 0; i < provincechilds[0].Childs.length; i++) {
          a.push(provincechilds[0].Childs[i].Name);
        }
        this.dayColumns[2].values = a;
        if (this.ProvinceAndCity[1] == "") {
          this.ProvinceAndCity[1] = provincechilds[0].Name; //修改默认市的名称
        }
        if (this.ProvinceAndCity[2] == "") {
          this.ProvinceAndCity[2] = provincechilds[0].Childs[0].Name;
        }
      }
      //市发生了变化
      if (this.ProvinceAndCityold[1] != this.ProvinceAndCity[1]) {
        //修改默认区的名称
        var citychilds = [];
        for (var i = 0; i < provincechilds.length; i++) {
          if (provincechilds[i].Name == this.ProvinceAndCity[1]) {
            citychilds = provincechilds[i].Childs;
            if (this.ProvinceAndCity[2] == "") {
              this.ProvinceAndCity[2] = citychilds[0].Name;
            }

            var a = [];
            for (var i = 0; i < citychilds.length; i++) {
              a.push(citychilds[i].Name);
            }
            this.dayColumns[2].values = a;
            break;
          }
        }
      }
      this.ProvinceAndCityold = this.ProvinceAndCity;
    }
  },
  created: function() {
    this.getProvinceWithCity();
  },
  methods: {
    validatesave: function() {
      var com = this.$refs;
      var flag = true;
      for (var c in com) {
        // if (this.$refs[c].length != undefined) {
        //   this.$refs[c][0].validate();
        //   flag = this.$refs[c][0].valid;
        // } else {
        //   this.$refs[c].validate();
        //   flag = this.$refs[c].valid;
        // }
        this.$refs[c].validate();
        flag = this.$refs[c].valid;

        if (!flag) return flag;
      }
      return flag;
    },
    getProvinceWithCity: function() {
      this.$http
        .get(
          this.GLOBAL.BASE_URL + "api/tbdeliveryaddress/getprovincewithcity",
          {
            params: {}
          }
        )
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.provinceWithCity = rep.Data;
              var p = [];
              var c = [];
              var a = [];
              for (var i = 0; i < this.provinceWithCity.length; i++) {
                p.push(this.provinceWithCity[i].Name);
              }
              for (var i = 0; i < this.provinceWithCity[0].Childs.length; i++) {
                c.push(this.provinceWithCity[0].Childs[i].Name);
              }
              for (
                var i = 0;
                i < this.provinceWithCity[0].Childs[0].Childs.length;
                i++
              ) {
                a.push(this.provinceWithCity[0].Childs[0].Childs[i].Name);
              }
              this.dayColumns = [
                {
                  values: p,
                  defaultIndex: 0
                },
                {
                  values: c,
                  defaultIndex: 0
                },
                {
                  values: a,
                  defaultIndex: 0
                }
              ];
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    zhi: function() {
      debugger;
      var ssqArr = [];

      if (
        this.Message == null ||
        this.Message == "" ||
        this.Message == undefined
      ) {
        return;
      }
      var result = AddressParse.parse(this.Message);
      console.log(result);

      this.formset.ReceiverName = result[0].name;
      this.formset.ReceiverPhone = result[0].mobile;
      if(result[0].province=="北京"||result[0].province=="天津"||result[0].province=="上海"||result[0].province=="重庆")
      {
        result[0].province+="市";
      }
      ssqArr.push(result[0].province);
      ssqArr.push(result[0].city);
      ssqArr.push(result[0].area==undefined?"":result[0].area);
      this.ProvinceAndCity = ssqArr;
      this.formset.Zipcode = result[0].code;
      this.formset.Address = result[0].details;
    },
    btnSave: function(id) {
      debugger;
      if (!this.validatesave()) {
        return;
      }
      if (this.ProvinceAndCity == "" || this.ProvinceAndCity == undefined) {
        Toast.fail("请选择省市区");
        return;
      }
      this.formset.Province = this.ProvinceAndCity[0];
      this.formset.City = this.ProvinceAndCity[1];
      this.formset.Area = this.ProvinceAndCity[2]==undefined?"":this.ProvinceAndCity[2];
      if (this.formset.IsDefaultAddress) {
        this.formset.IsDefaultAddress = 1;
      } else {
        this.formset.IsDefaultAddress = 0;
      }
      this.$http
        .post(
          this.GLOBAL.BASE_URL + "api/tbdeliveryaddress/add",
          this.formset,
          {
            emulateJSON: true
          }
        )
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              Toast.success("保存成功");
              window.history.go(-1);
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    onChange(picker, value) {
      this.$nextTick(() => {
        console.log(picker.getValues());
      });
    },

    confirmDayTime: function(picker) {
      this.ProvinceAndCity = picker.getValues();
      this.ProvinceAndCityold = ProvinceAndCity;
    }
  },
  filters: {
    pickerValueFilter(val) {
      debugger;
      if (Array.isArray(val)) {
        return val.toString();
      } else {
        return "请选择";
      }
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/deliveryaddress/deliveryaddressadd.vue